var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1410126413",
    clipPath: "url(#clip0_242_5139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4249"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1928",
    x: 0.5,
    y: 1.5,
    width: 11,
    height: 11,
    rx: 3.5,
    fill: "white",
    stroke: "#0C995E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1929",
    x: 2.98539,
    y: 3.98542,
    width: 6.02864,
    height: 6.02864,
    rx: 3.01432,
    fill: "#0C995E",
    stroke: "#0C995E",
    strokeWidth: 0.637771
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_242_5139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.88855)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegIcon);
export default __webpack_public_path__ + "static/media/VegIcon.bae07f8571fd6b988e1f6a5230bceba8.svg";
export { ForwardRef as ReactComponent };